import request from '@/utils/requestApi';
import LoadScript from '../../utils/loadScript';

async function load(finder) {
  finder.source = 'path';
  try {
    const response = await request({
      url: `/v3/brand_channel_discovery/path`,
      method: 'post',
      data: { finder },
      headers: {
        'Videobot-Token': localStorage.getItem('TOKEN_VIDEOBOT')
      },
    });
    window.__ovmSID = response.data.tape.session_id;
    window.ovmConfig = response.data.tape.ovmConfig;
    window.ovmConfig.env.devMode = false;
    
    this.tape = response.data.tape
  } catch (error) {
    if (error.response && error.response.status === 401) {
      if (process.env.VUE_APP_VIDEO_ID === '654b7f18bf15bb000295a605') {
        window.location.href = 'https://staging.video.bot/home/vivo/vivomaisfamilia/video?id=af759b81-811c-44cd-8278-fdc1b2144c64';  // Altere para a URL desejada
      } else {
        window.location.href = 'https://video.bot/home/vivo/vivomaisfamilia/video?id=cfbcc4bf-fcc7-4bc0-a841-0095775c6000';  // Altere para a URL desejada
      }
      
    } else {
      console.warn(error);
    }
    console.warn(error);
  }
}

async function loadDev() {
  try {
    var data = {
      tape: {
        video_id:  process.env.VUE_APP_VIDEO_ID,
        brand_channel: {
          background: '',
          banner: '',
          campaign_id: '',
          client_name: 'clone0705',
          created_at: '2023-06-22T10:58:23.003-03:00',
          description: 'Descrição',
          expirated_html: 'Mensagem de expiração',
          header_color: '',
          logo: '',
          title: 'vue',
          title_color: '',
          updated_at: '2023-06-22T10:58:23.135-03:00',
          video_id: '645800da65a8680009f50623',
          video_name: 'vue-teste',
          id: '6494537f0cda97000967b138',
        },
        session_id: '',
        path: '',
        expired: false,
      },
    };
    await LoadScript('.jb/ovmConfig.js');
    await LoadScript('.jb/custom_fields.js');
    window.ovmConfig.env.devMode = true;
    window.__ovmSID = 'OVM-1';
    this.tape = data.tape
  } catch (error) {
    console.warn(error);
  }
}

export const actions = {
  load,
  loadDev
}